import { PropsWithChildren } from 'react';
import { makeStyles } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
import CategoryIcon from '@material-ui/icons/Category';
import ExtensionIcon from '@material-ui/icons/Extension';
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import GetAppIcon from '@material-ui/icons/GetApp';
import VideoLibraryIcon from '@material-ui/icons/VideoLibrary';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import LibraryAddIcon from '@material-ui/icons/LibraryAdd';
import DescriptionIcon from '@material-ui/icons/Description';
import AssignmentIcon from '@material-ui/icons/Assignment';
import DashboardIcon from '@material-ui/icons/Dashboard';
import TimelineIcon from '@material-ui/icons/Timeline';
import AnnouncementIcon from '@material-ui/icons/Announcement';
import { ActiveNoticeBanner } from '../devops-news';
import LogoFull from './LogoFull';
import LogoIcon from './LogoIcon';
import {
  Settings as SidebarSettings,
  UserSettingsSignInAvatar,
} from '@backstage/plugin-user-settings';
import { SidebarSearchModal } from '@backstage/plugin-search';
import {
  Sidebar,
  sidebarConfig,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarPage,
  SidebarScrollWrapper,
  SidebarSpace,
  useSidebarOpenState,
  Link,
} from '@backstage/core-components';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import { MyGroupsSidebarItem } from '@backstage/plugin-org';
import GroupIcon from '@material-ui/icons/People';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { identityApiRef, useApi } from '@backstage/core-plugin-api';
import { ReleasesSidebarItem } from '../releases';
import { TeamsSidebarItem } from '../teams';

const useSidebarLogoStyles = makeStyles({
  root: {
    width: sidebarConfig.drawerWidthClosed,
    height: 3 * sidebarConfig.logoHeight,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    marginBottom: -14,
  },
  link: {
    width: sidebarConfig.drawerWidthClosed,
    marginLeft: 24,
  },
});

const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </Link>
    </div>
  );
};

export const Root = ({ children }: PropsWithChildren<{}>) => {
  const identityApi = useApi(identityApiRef);

  return (
  <SidebarPage>
    <Sidebar>
      <SidebarLogo />
      <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
        <SidebarSearchModal />
      </SidebarGroup>
      <SidebarDivider />
      <SidebarGroup label="Menu" icon={<MenuIcon />}>
        {/* Global nav, not org-specific */}
        <SidebarItem icon={HomeIcon} to="/" text="Home" />
        <SidebarItem icon={CategoryIcon} to="catalog" text="Catalog" />
        <MyGroupsSidebarItem
          singularTitle="My Group"
          pluralTitle="My Groups"
          icon={GroupIcon}
        />
        <SidebarItem icon={ExtensionIcon} to="api-docs" text="APIs" />
        <SidebarItem icon={PhoneAndroidIcon} to="android-releases" text="Android" />
        <SidebarItem icon={GetAppIcon} to="mobile-builds" text="Builds móviles" />
        <SidebarItem icon={DescriptionIcon} to="reports" text="Reports" />
        <SidebarItem icon={AnnouncementIcon} to="devops-news" text="Novedades DevOps" />
        <ReleasesSidebarItem />
        <TeamsSidebarItem />
        <SidebarItem icon={DashboardIcon} to="eco-dashboard" text="Tablero por ECO" />
        <SidebarItem icon={TrackChangesIcon} to="tech-radar" text="Tech Radar" />
        <SidebarItem icon={LibraryAddIcon} to="create" text="Autoservicio" />
        <SidebarItem icon={AssignmentIcon} to="my-requests" text="Mis solicitudes" />
        <SidebarItem icon={TimelineIcon} to="usage" text="Uso de Backstage" />
        <SidebarItem icon={ReportProblemIcon} to="snyk-ignores" text="Excepciones Snyk" />
        <SidebarItem icon={VideoLibraryIcon} to="videos" text="Videos" />
        {/* End global nav */}
        <SidebarDivider />
        <SidebarScrollWrapper>
          {/* Items in this group will be scrollable if they run out of space */}
        </SidebarScrollWrapper>
      </SidebarGroup>
      <SidebarSpace />
      <SidebarDivider />
      <NotificationsSidebarItem />
      <SidebarDivider />
      <SidebarGroup
        label="Settings"
        icon={<UserSettingsSignInAvatar />}
        to="/settings"
      >
        <SidebarSettings />
      </SidebarGroup>
      <SidebarDivider />
      <SidebarItem
        icon={ExitToAppIcon}
        text="Logout"
        onClick={() => identityApi.signOut()}
      />
    </Sidebar>
    <ActiveNoticeBanner />
    {children}
  </SidebarPage>
  );
};
